<div class="app-inner-layout">
    <section class="container header-section-website">
        <div class="row">
            <div class="col-8 flex-row d-flex justify-content-start align-items-center">
                <a href="https://www.mobilitateurbana4.ro" class="back-link"><i class="fa-solid fa-angles-left"></i>
                    Înapoi în site</a>
            </div>
            <div class="col-4 flex-row d-flex justify-content-end align-items-center">
                <a href="https://www.mobilitateurbana4.ro">
                    <img src="../../../assets/img/logo-ps4-dmu.png" class="img-fluid" />
                </a>
            </div>
        </div>
    </section>
    <section class="container-fluid header-bg">
        <div class="bg-overlay"></div>
        <div class="row">
            <div class="container">
                <div class="col-sm-12">
                    <h4>MOBILITATE URBANĂ</h4>
                    <br />
                    <h1>Registratură Online</h1>
                </div>
            </div>
        </div>
    </section>
    <!-- <div class="container">
        <div class="row mb-5 pb-5 mt-5">
            <div class="col-12 divider-line-heading">
                <h3 style="color: red">Vă informăm că, începând cu data de 24 decembrie 2024, se vor desfășura lucrări
                    de mentenanță în
                    aplicația informatică, necesare pentru finalizarea procesului de închidere a anului fiscal 2024 și
                    pregătirea deschiderii anului fiscal 2025 în cele mai bune condiții. Vă mulțumim!</h3>
            </div>
        </div>
    </div> -->

    <!-- <div class="container hidden">
        <div class="row mb-5 pb-5 mt-5">
            <div class="col-12 divider-line-heading">
                <h3 style="color: red">În perioada 1 mai(Joi) – 4 mai (Duminică), ora 17:00, sunt programate lucrări de mentenanță în vederea îmbunătățirii procesului de digitalizare, fapt care poate cauza întreruperi temporare în utilizarea serviciilor DMU Sector 4. 
                    <br/>
                    Vă mulțumim pentru înțelegere!</h3>
            </div>
        </div>
    </div> -->

    <div class="container">
        <div class="row mb-5 pb-5 mt-5" *ngIf="tipPersoana === null">
            <!-- <div class="col-sm-12 flex-center">
                <h2 class="manropeFamily">Alegeți tip persoană</h2>
            </div> -->
            <div class="col-12 divider-line-heading">
                <div>
                    <span class="outer-line"></span>
                    <span class="fa fa-user-circle" aria-hidden="true"></span>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Alegeți tip persoană</h3>
            </div>
        </div>
        <div class="row" *ngIf="tipPersoana === null">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-6">
                        <div class="bg-item-overlay"></div>
                        <div class="choice-wrapper header-bg">
                            <div class="choice-box" (click)="chooseTipPersoana('1')">

                                <div class="choice-img">
                                    <i class="fa fa-user"></i>
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">PERSOANĂ FIZICĂ</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="bg-item-overlay"></div>
                        <div class="choice-wrapper header-bg">
                            <div class="choice-box" (click)="chooseTipPersoana('2')">

                                <div class="choice-img">
                                    <i class="fa fa-briefcase"></i>
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">PERSOANĂ JURIDICĂ</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <div class="choice-wrapper">
                    <div class="choice-box" (click)="chooseTipPersoana('1')">
                        
                        <div class="choice-img">
                            <i class="fa fa-user"></i>
                        </div>
                        <div class="choice-text">
                            <p class="manropeFamily">PERSOANĂ FIZICĂ</p>
                        </div>
                    </div>
                    <div class="choice-box" (click)="chooseTipPersoana('2')">
                        <div class="bg-item-overlay"></div>
                        <div class="choice-img">
                            <i class="fa fa-briefcase"></i>
                        </div>
                        <div class="choice-text">
                            <p class="manropeFamily">PERSOANĂ JURIDICĂ</p>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="col-sm-12 white-bg p-5" *ngIf="notice && notice.length > 0">
            <div class="row" *ngFor="let item of notice">
                <div class="border-notice mb-3">
                    <p class="text-center red-text"><strong>{{item.title}}</strong></p>
                    <br />
                    <div [innerHtml]="item.content" class="manropeFamily"></div>
                    <!-- <p class="text-center"><strong>{{item.content}} </strong></p> -->
                </div>
            </div>
        </div>


        <div class="row" *ngIf="sectionChosen === null && tipPersoana != null && (!forms || forms.length === 0)">
            <div class="col-sm-12 text-center pt100 pb100">
                <div class="row">
                    <div class="col-12">
                        <!-- <button mat-raised-button class="float-right m5" type="button" >RESET</button> -->
                        <button type="button" class="btn btn-outline-secondary float-right m5"
                            (click)="resetAll()">Reset</button>
                    </div>
                    <div class="col-12 divider-line-heading">
                        <div>
                            <span class="outer-line"></span>
                            <i class="fa-solid fa-book"></i>
                            <span class="outer-line"></span>
                        </div>
                        <h3 class="manropeFamily">Alegeți o categorie</h3>
                        <h6>
                            <small style="" class="text-center" *ngIf="tipPersoana == 1">-- PERSOANĂ FIZICĂ
                                --</small>
                            <small style="" class="text-center" *ngIf="tipPersoana == 2">-- PERSOANĂ JURIDICĂ
                                --</small>
                        </h6>
                    </div>
                </div>
                <!-- <h2 class="manropeFamily">Alegeți o categorie<br />
                    <small style="font-size:50%" class="text-center" *ngIf="tipPersoana == 1">-- PERSOANA FIZICA
                        --</small>
                    <small style="font-size:50%" class="text-center" *ngIf="tipPersoana == 2">-- PERSOANA JURIDICA
                        --</small>
                </h2> -->
            </div>
        </div>


        <div class="container" *ngIf="sectionChosen === null && tipPersoana != null && (!forms || forms.length === 0)">
            <div class="row">
                <div class="col-12">
                    <!-- <div class="choice-box  col-4 align-self-center flex-center" (click)="chooseTipCategorie('1')"
                        (click)="getForms()">
                        <div class="choice-img">
                            <img src="/assets/img/icon_parcare_resedinta.png" alt="image">
                        </div>
                        <div class="choice-text">
                            <p>PARCARI RESEDINTA</p>
                        </div>
                    </div>
                    <div class="choice-box  col-4 align-self-center flex-center" (click)="chooseTipCategorie('2')"
                        (click)="getForms()">
                        <div class="choice-img">
                            <img src="/assets/img/parking2.png" alt="image">
                        </div>
                        <div class="choice-text">
                            <p>PARCARI PUBLICE</p>
                        </div>
                    </div> -->
                    <div class='row'>
                        <div class='col-sm-12 col-md-6'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('1')" (click)="getForms()">
                                <div class="choice-img">
                                    <img src="/assets/img/parking-resedinta-white.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">PARCARE REȘEDINȚĂ</p>
                                </div>
                            </div>
                        </div>
                        <div class='col-sm-12 col-md-6'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('2')" (click)="getForms()">

                                <div class="choice-img">
                                    <img src="/assets/img/parking-publice-white.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">PARCARE PUBLICĂ</p>
                                </div>
                            </div>
                        </div>

                        <!-- <div class='col-sm-12 col-md-4'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('4')" (click)="getForms()">

                                <div class="choice-img">
                                    <img src="/assets/img/buildings-trees-and-plants-in-cityscape-view.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">Blocări Auto</p>
                                </div>
                            </div>
                        </div> -->

                        <!-- <div class='col-sm-12 col-md-4'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('27')" (click)="getForms()">

                                <div class="choice-img">
                                    <img src="/assets/img/tow-truck.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">RIDICĂRI/ELIBERĂRI AUTO</p>
                                </div>
                            </div>
                        </div> -->

                    </div>
                    <div class="row">

                        <!-- <div class='col-sm-12 col-md-6'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('5')" (click)="getForms()">

                                <div class="choice-img">
                                    <img src="/assets/img/chat.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">AUDIENȚE</p>
                                </div>
                            </div>
                        </div> -->

                        <div class='col-sm-12 col-md-6'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('7')" (click)="getForms()">

                                <div class="choice-img">
                                    <img src="/assets/img/parking-publice-white.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <!-- <p class="manropeFamily">TAXA SPECIALĂ PENTRU DEZVOLTARE URBANĂ</p> -->
                                    <p class="manropeFamily">TARIF ANUAL PARCARE PUBLICĂ STRADALĂ</p>
                                </div>
                            </div>
                        </div>

                        <div class='col-sm-12 col-md-6'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('6')" (click)="getForms()">

                                <div class="choice-img">
                                    <img src="/assets/img/suport.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">SUPORT TEHNIC</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class='col-sm-6'>
                            <div class="bg-item-overlay"></div>
                            <div class="choice-box align-self-center flex-center header-bg"
                                (click)="chooseTipCategorie('8')" (click)="getForms()">

                                <div class="choice-img">
                                    <img src="/assets/img/conversation.png" alt="image">
                                </div>
                                <div class="choice-text">
                                    <p class="manropeFamily">LEGEA 544/2001</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <!-- <div class="container" *ngIf="sectionChosen === null && tipPersoana != null && (!forms || forms.length === 0)"> -->

        <div class="row" *ngIf="sectionChosen === null && tipPersoana != null && (forms && forms.length > 0)">
            <div class="col-sm-12 text-center pt100 pb100">
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-outline-secondary float-right m5"
                            (click)="resetAll()">Reset</button>
                    </div>
                    <div class="col-12 divider-line-heading">
                        <div>
                            <span class="outer-line"></span>
                            <i class="fa-solid fa-sitemap"></i>
                            <span class="outer-line"></span>
                        </div>
                        <h3 class="manropeFamily">Alegeți o secțiune</h3>
                        <h6>
                            <small class="text-center" *ngIf="tipPersoana == 1">-- PERSOANA FIZICA
                                --</small>
                            <small class="text-center" *ngIf="tipPersoana == 2">-- PERSOANA JURIDICA
                                --</small>
                        </h6>
                    </div>

                </div>
                <!-- <button mat-raised-button class="float-right m5" type="button" (click)="resetAll()">RESET</button>
                <h2 class="manropeFamily">Alegeți o sectiune<br /> -->
                <!-- <small style="font-size:50%" class="text-center">-- {{ currentCategory }} --</small><br/> -->
                <!-- <small style="font-size:50%" class="text-center" *ngIf="tipPersoana == 1">-- PERSOANA FIZICA
                        --</small>
                    <small style="font-size:50%" class="text-center" *ngIf="tipPersoana == 2">-- PERSOANA JURIDICA
                        --</small>
                </h2> -->
            </div>
        </div>


        <div class="row" *ngIf="sectionChosen === null && tipPersoana != null && forms && forms.length > 0">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12 smallSectionBox">
                        <div class="smallSectionHeader header-bg">
                            <h3 class="manropeFamily">{{ currentCategory }}</h3>
                        </div>
                        <div class="smallSectionList">
                            <ul class="custom-list-choice">
                                <li class="manropeFamily" *ngFor="let item of forms; index as i"
                                    (click)="chooseSection(item.id); getFormStructure()">{{ i+1 }}. {{ item.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 mb-5 pb-5">
                <p>&nbsp;</p>
            </div>
        </div>



        <!-- IDENTIFICARE -->


        <div class="col-sm-12 mt-5" *ngIf="sectionChosen !== null">
            <div class="col-sm-12 text-center pb50">
                <div class="col-sm-12 white-bg pt-5">
                    <!-- <button mat-raised-button class="float-right m5" type="button" (click)="resetForm()">ÎNAPOI</button> -->
                    <button type="button" class="btn btn-outline-secondary float-right m5"
                        (click)="resetAll()">Reset</button>
                </div>
                <h1 class="text-center manropeFamily">{{currentSection}}</h1>
            </div>
        </div>
        <div class="col-sm-12 mt-5" *ngIf="sectionChosen !== null">
            <div class="col-12 divider-line-heading">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-regular fa-id-card"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Identificare</h3>
            </div>
            <!-- <h4 class="section-title border-bottom mt-5">Identificare </h4> -->
            <div class="col-sm-12">
                <div class="row">
                    <form *ngIf="identificareForm" [formGroup]="identificareForm">
                        <div class="row">
                            <div *ngFor="let item of formStructure.form.identificare; let i = index;"
                                class="{{item.design_view_small ? item.design_view_small : 'col-sm-12'}}
                            {{item.design_view_md ? item.design_view_md : 'col-md-6'}} {{item.design_view_lg ? item.design_view_lg : 'col-lg-4'}}">

                                <!-- input -->
                                <div class="form-group" *ngIf="['text','number','tel','email'].includes(item.type)"
                                    id="parent">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline" class="custom-input">
                                        <input matInput id="{{item.name}}" class="custom-input"
                                            formControlName="{{item.name}}" [type]="item.type"
                                            [required]="item.required" name="{{item.name}}" [minlength]="item.min"
                                            [maxlength]="item.max">
                                    </mat-form-field>
                                </div>

                                <!-- textarea -->
                                <div class="form-group" *ngIf="item.type == 'textarea'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input matInput id="{{item.name}}" formControlName="{{item.name}}"
                                            [type]="item.type" [required]="item.required" name="{{item.name}}"
                                            [minlength]="item.min" [maxlength]="item.max">
                                    </mat-form-field>
                                </div>

                                <!-- select-element -->
                                <div class="form-group" *ngIf="item.type == 'select' && item.name !== 'id_address'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <mat-select matSelect formControlName="{{item.name}}" [required]="item.required"
                                            attr.name="{{item.name}}">
                                            <mat-option value="{{val.id}}" *ngFor="let val of item.values">
                                                {{val.label}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>


                                <!-- id_address -->
                                <div class="form-group" *ngIf="item.type == 'select' && item.name === 'id_address'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto"
                                            [required]="item.required">
                                        <!-- (blur)="onInputBlur()" -->
                                        <mat-autocomplete #auto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'identificareForm')"
                                            [displayWith]="displayFn">
                                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                                {{option.text}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>

                <div *ngIf="this.checkForInfo(1)">
                    <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                        <i>
                            Informatii
                        </i>
                    </p>
                </div>
                <div *ngIf="formStructure && formStructure.form.info.length > 0">
                    <div *ngFor="let item of formStructure.form.info">
                        <ng-container *ngIf="item.type_id === 1">
                            <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                                <i>
                                    {{ item.text }}
                                </i>
                            </p>
                        </ng-container>
                    </div>
                </div>



            </div>

            <div class="col-12 divider-line-heading">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-solid fa-circle-info"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Informații</h3>
            </div>

            <!-- <h4 class="section-title border-bottom ">Informații </h4> -->
            <div class="col-sm-12">
                <div class="row">
                    <form *ngIf="informatiiForm" [formGroup]="informatiiForm">
                        <div class="row">
                            <div *ngFor="let item of formStructure.form.informatii; let i = index;" class="{{item.design_view_small}}
                            {{item.design_view_md}} {{item.design_view_lg}}">

                                <!-- input -->

                                <div class="form-group" *ngIf="['text','number','tel','email'].includes(item.type)">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input matInput id="{{item.name}}" formControlName="{{item.name}}"
                                            [type]="item.type" [required]="item.required" name="{{item.name}}"
                                            [minlength]="item.min" [maxlength]="item.max">
                                    </mat-form-field>
                                </div>

                                <!-- textarea -->
                                <div class="form-group" *ngIf="item.type == 'textarea'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <textarea matInput id="{{item.name}}" formControlName="{{item.name}}"
                                            [type]="item.type" [required]="item.required" name="{{item.name}}"
                                            [minlength]="item.min" [maxlength]="item.max"></textarea>
                                    </mat-form-field>
                                </div>

                                <!-- select -->
                                <div class="form-group" *ngIf="item.type == 'select' && item.name !== 'id_address'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <mat-select matSelect formControlName="{{item.name}}" [required]="item.required"
                                            attr.name="{{item.name}}">
                                            <mat-option value="{{val.id}}" *ngFor="let val of item.values">
                                                {{val.label}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>


                                <!-- id_address -->
                                <div class="form-group" *ngIf="item.type == 'select' && item.name === 'id_address'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto"
                                            (blur)="onInputBlur()" [required]="item.required">
                                        <mat-autocomplete #auto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'informatiiForm')">
                                            <mat-option *ngFor="let option of filteredOptions | async"
                                                [value]="option.text">
                                                {{option.text}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>

                                <!-- date-->
                                <div class="form-group" *ngIf="item.type == 'date'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field *ngIf="item.type == 'date'" appearance="outline">
                                        <input matInput [matDatepicker]="i" name="{{item.name}}"
                                            formControlName="{{item.name}}" readonly (focus)="i.open()">
                                        <mat-datepicker-toggle matSuffix [for]="i"></mat-datepicker-toggle>
                                        <mat-datepicker #i></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div *ngIf="this.checkForInfo(2)">
                    <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                        <i>
                            Informatii
                        </i>
                    </p>
                </div>
                <div *ngIf="formStructure && formStructure.form.info.length > 0">
                    <div *ngFor="let item of formStructure.form.info">
                        <ng-container *ngIf="item.type_id === 2">
                            <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                                <i>
                                    {{ item.text }}
                                </i>
                            </p>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="col-12 divider-line-heading" *ngIf="extraInformatiiLength > 0">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-solid fa-circle-info"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Extra Informații</h3>
            </div>

            <!-- <h4 class="section-title border-bottom" *ngIf="extraInformatiiLength > 0">Informații extra</h4> -->
            <div class="col-sm-12">
                <div class="row">
                    <form *ngIf="extraInformatiiForm" [formGroup]="extraInformatiiForm">
                        <div class="row">
                            <div *ngFor="let item of formStructure.form.extra; let i = index;" class="{{item.design_view_small}}
                            {{item.design_view_md}} {{item.design_view_lg}}">

                                <!-- input -->

                                <div class="form-group" *ngIf="['text','number','tel','email'].includes(item.type)">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input matInput id="{{item.name}}" formControlName="{{item.name}}"
                                            [type]="item.type" [required]="item.required" name="{{item.name}}"
                                            [minlength]="item.min" [maxlength]="item.max">
                                    </mat-form-field>
                                </div>

                                <!-- textarea -->

                                <div class="form-group" *ngIf="item.type == 'textarea'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <textarea matInput id="{{item.name}}" formControlName="{{item.name}}"
                                            [type]="item.type" [required]="item.required" name="{{item.name}}"
                                            [minlength]="item.min" [maxlength]="item.max"></textarea>
                                    </mat-form-field>
                                </div>

                                <!-- select -->

                                <div class="form-group" *ngIf="item.type == 'select' && item.name !== 'id_address'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <mat-select matSelect formControlName="{{item.name}}" [required]="item.required"
                                            attr.name="{{item.name}}">
                                            <mat-option value="{{val.id}}" *ngFor="let val of item.values">
                                                {{val.label}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- <mat-form-field class="example-full-width mt-2 mb-2" floatLabel="always"
                                    *ngIf="item.type == 'select' && item.name === 'id_address'">
                                    <mat-label>{{item.label}} <span class="red-text" *ngIf="item.required"></span>
                                    </mat-label>
                                    <mat-select matSelect formControlName="{{item.name}}" [required]="item.required"
                                        attr.name="{{item.name}}">
                                        <mat-option value="1">
                                            test1
                                        </mat-option>
                                        <mat-option value="2">
                                            test2
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field> -->

                                <div class="form-group" *ngIf="item.type == 'select' && item.name === 'id_address'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto"
                                            (blur)="onInputBlur()" [required]="item.required">
                                        <mat-autocomplete #auto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'extraInformatiiForm')">
                                            <mat-option *ngFor="let option of filteredOptions | async"
                                                [value]="option.text">
                                                {{option.text}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>

                                <!-- date-->

                                <!-- <mat-form-field class="example-full-width mt-2 mb-2" floatLabel="always"
                                    *ngIf="item.type == 'date'">
                                    <mat-label>{{item.label}} <span class="red-text" *ngIf="item.required"></span>
                                    </mat-label>
                                    <input matInput [matDatepicker]="i" name="{{item.name}}"
                                        formControlName="{{item.name}}">
                                    <mat-datepicker-toggle matSuffix [for]="i"></mat-datepicker-toggle>
                                    <mat-datepicker #i disabled="false"></mat-datepicker>
                                </mat-form-field> -->

                                <div class="form-group" *ngIf="item.type == 'date'">
                                    <label for="{{item.name}}">{{item.label}} <span class="red-text"
                                            *ngIf="item.required">*</span></label>
                                    <mat-form-field *ngIf="item.type == 'date'" appearance="outline">
                                        <input matInput [matDatepicker]="i" name="{{item.name}}"
                                            formControlName="{{item.name}}" readonly (focus)="i.open()">
                                        <mat-datepicker-toggle matSuffix [for]="i"></mat-datepicker-toggle>
                                        <mat-datepicker #i disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div *ngIf="this.checkForInfo(4)">
                    <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                        <i>
                            Informatii
                        </i>
                    </p>
                </div>
                <div *ngIf="formStructure && formStructure.form.info.length > 0">
                    <div *ngFor="let item of formStructure.form.info">
                        <ng-container *ngIf="item.type_id === 4">
                            <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                                <i>
                                    {{ item.text }}
                                </i>
                            </p>
                        </ng-container>
                    </div>
                </div>
            </div>


            <!-- documente -->
            <div class="col-12 divider-line-heading" *ngIf="fisiereForm">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Documente necesare</h3>
            </div>
            <div class="col-sm-12 mt-5 pb-3" *ngIf="fisiereForm">
                <!-- <div class="row">
                    <div class="col-sm-12 pb-3">
                        <h4 class="section-title border-bottom manropeFamily">Documente necesare</h4>
                    </div>
                </div> -->

                <div class="row">
                    <div class="col-sm-12" *ngFor="let item of formStructure.form.fisiere; let i = index">

                        <div class="file-upload-wrapper d-flex flex-column file-upload-wrapper-uploaded">
                            <div class="w-100 d-flex justify-content-between">
                                <mat-label>{{item.label}} <span class="red-text" *ngIf="item.required">*</span>
                                </mat-label>

                                <div class="right-section">
                                    <!-- to solve later on, problem!!! -->
                                    <!-- <a mat-raised-button [href]="item.model" target="_blank"
                                        *ngIf="item.hasOwnProperty('downloadable') && item.downloadable === 1"
                                        color="warn" class="mr-4 upload-button">
                                        <mat-icon>cloud_download</mat-icon>
                                        <span>DESCARCĂ</span>
                                    </a> -->
                                    <button mat-raised-button id="upload-button-0" class="upload-button" type="button"
                                        *ngIf="!uploading[item.name]" color="primary"
                                        (click)="clickFileItem('file_' + item.name)">
                                        <mat-icon class="mr-2">cloud_upload</mat-icon>
                                        <span>ÎNCARCĂ</span>
                                    </button>
                                </div>
                            </div>
                            <div class="w-100 px-3" *ngIf="filesArr[item.name].length > 0">
                                <p style="color: black;"><u><strong>Documente încărcate:</strong></u></p>
                                <ul class="documentsList list-unstyled">
                                    <li *ngFor="let row of filesArr[item.name]; index as i" class="w-100">
                                        <div class="row">
                                            <div class="col-sm-9">
                                                <p class="text-left">{{i + 1}}. {{row.original_name}}</p>
                                            </div>
                                            <div class="col-sm-3">
                                                <button mat-icon-button class="upload-icon-button upload-icon-button-2"
                                                    type="button" matTooltip="Șterge fișierul încărcat"
                                                    (click)="removeFile(item.name, i)">
                                                    <mat-icon>clear</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!-- <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading[item.name]">
                            </mat-spinner> -->

                            <input type="file"
                                accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                id="upload-file-item-0" #file_{{item.name}} id="file_{{item.name}}"
                                (change)="upload($event.target, item.name)" name="file_{{item.name}}"
                                style="display: none">
                        </div>
                    </div>
                </div>
                <div *ngIf="this.checkForInfo(3)">
                    <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                        <i>
                            Informatii
                        </i>
                    </p>
                </div>
                <div *ngIf="formStructure.form.info.length > 0">
                    <div *ngFor="let item of formStructure.form.info">
                        <ng-container *ngIf="item.type_id === 3">
                            <p class="small-footer-section manropeFamily" style="margin-bottom: 0;">
                                <i>
                                    {{ item.text }}
                                </i>
                            </p>
                        </ng-container>
                    </div>
                </div>

            </div>
            <div class="col-sm-12">
                <mat-checkbox [(ngModel)]="terms.declar_propria_rasp" name="declar_propria_rasp">
                    Declar în deplină cunoștință și pe proprie răspundere, cunoscând dispozițiile art. 326 Cod
                    Penal
                    referitoare la falsul în declarații
                </mat-checkbox> <br /><br />

                <mat-checkbox [(ngModel)]="terms.declar_acte" name="declar_acte">
                    Declar că sunt de acord cu transmiterea actelor administrative pe cale electronică
                </mat-checkbox> <br /><br />

                <mat-checkbox [(ngModel)]="terms.terms" name="terms">
                    Sunt de acord cu <a href="https://www.mobilitateurbana4.ro/politica-de-confidentialitate/"
                        target="_blank">Termenii și Condițiile de Confidențialitate</a>
                    <span class="red-text">(*)</span>
                    (conform GDPR)
                </mat-checkbox><br /><br />
            </div>

            <div class="col-sm-12 pb100">
                <p class="float-left"><strong><i class="red-text fa fa-fw fa-info-circle"></i> Câmpurile marcate
                        cu
                        <span class="red-text">*</span> sunt obligatorii</strong> <br />
                    <span><strong><i class="red-text fa fa-fw fa-info-circle"></i> Fișierele atașate trebuie să
                            fie
                            de
                            tip imagine sau PDF, de maxim 10MB fișierul</strong></span>
                </p>
                <button type="submit" (click)="submit()"
                    class="mb-2 mr-2 btn-transition btn-block btn-lg btn btn-outline-primary float-right">
                    TRIMITE
                </button>
            </div>
        </div>

        <!-- <div class="faq-container" *ngIf="faqList && faqList.length > 0">
            <h2>FAQ</h2>

            <div class="faq-item" *ngFor="let faqItem of faqList">
                <h3 class="faq-question">{{ faqItem.name }}</h3>
                <div class="faq-answer">{{ faqItem.description }}</div>
            </div>
        </div> -->

    </div>


    <!-- </body> -->
    <div *ngIf="loading">
        <ngx-loading [show]="loading"
            [config]="{backdropBorderRadius: '3px', backdropBackgroundColour: 'rgba(0, 0, 0, 0.5)'}"
            [template]="loadingTemplate" class="npx-loading-class">
        </ngx-loading>
        <h4 class="loading-text">Vă rugăm așteptați!</h4>
    </div>
</div>